import { SECONDS_IN_MINUTE } from './constants';

export const convertSecondsToMinutesAndSeconds = (totalSeconds: number) => {
	const minutes = Math.floor(totalSeconds / SECONDS_IN_MINUTE);
	const seconds = totalSeconds % SECONDS_IN_MINUTE;

	return {
		minutes,
		seconds,
	};
};

export const convertMinutesAndSecondsToSeconds = (minutes: number, seconds: number) => {
	return minutes * 60 + seconds;
};

export const formatTime = (time: number) => {
	return time.toString().padStart(2, '0');
};

export const isValidMinutesInput = (timeInput: string) => {
	const time = Number(timeInput);
	return !Number.isNaN(time) && Number.isInteger(time) && time >= 0;
};

export const isValidSecondsInput = (timeInput: string) => {
	const time = Number(timeInput);
	return !Number.isNaN(time) && Number.isInteger(time) && time >= 0 && time <= SECONDS_IN_MINUTE;
};
